import { render, staticRenderFns } from "./ArtworkProfile.vue?vue&type=template&id=54a14d9a&scoped=true&"
import script from "./ArtworkProfile.vue?vue&type=script&lang=js&"
export * from "./ArtworkProfile.vue?vue&type=script&lang=js&"
import style0 from "./ArtworkProfile.vue?vue&type=style&index=0&id=54a14d9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a14d9a",
  null
  
)

export default component.exports